import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------product page api's-------------------------------->
    getAmcServices(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/composite/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getAmcExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/composite/export/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    getcompositedetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/composite/compositedetails')
    },
    /**
     * create api 
     * @param {*} form 
     */
    postAmcService(form, token) {

        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/composite/create', form)
    },
    getProductBundleView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/composite/viewpage/' + id)
    },
    /**
     * getAmcSerivice from particular id
     */
    getAmcService(id,type, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/composite/view/' + id + '?type=' + type)
    },
    /**
     * update api
     * @param {*} form 
     * @param {*} id 
     */
    postAmcServiceUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/composite/update/' + id, form)
    },
    postpdtdelete(ids, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/composite/bulkdelete', ids)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} data 
     */
    getProductDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/composite/singledelete', data)
    },
    /**
     *  product status changes
     * @param {*} data 
     * @param {*} token 
     */
    postPdtstatus(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/composite/statuschange', data)
    },
       /**
     *  product status changes
     * @param {*} data 
     * @param {*} token 
     */
    postsinglestatus(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/composite/singlestatuschange', data)
    },

}